import { Injectable, signal, computed } from '@angular/core';
import { UploadedDocument } from '@app/features/document-submission/document-submission.component';

export interface UploadState {
  documents: UploadedDocument[];
  sessionId: string;
}
@Injectable({
  providedIn: 'root'
})
export class UploadDocumentStateService {

  // ✅ Private state signals
  private readonly _documents = signal<UploadedDocument[]>([]);
  private readonly _sessionId = signal<string>(`${Date.now()}`);

  // ✅ Public readonly signals
  readonly documents = this._documents.asReadonly();
  readonly sessionId = this._sessionId.asReadonly();

  // ✅ Computed values
  readonly documentCount = computed(() => this._documents().length);
  readonly hasDocuments = computed(() => this._documents().length > 0);

  constructor() { }

  /**
   * ✅ Add a document to the state
   */
  addDocument(document: UploadedDocument): void {
    console.log('📄 Adding document:', document.name);
    
    this._documents.update(docs => {
      const updated = [...docs, document];
      return updated;
    });
    
  }

  
  /**
   * ✅ Add multiple documents
   */
  addDocuments(documents: UploadedDocument[]): void {
    
    this._documents.update(docs => {
      const updated = [...docs, ...documents];
      return updated;
    });
  }

  /**
   * ✅ Remove a document by index
   */
  removeDocumentByIndex(index: number): void {
    
    this._documents.update(docs => {
      const updated = docs.filter((_, i) => i !== index);
      return updated;
    });
  }

  removeDocumentById(docId: string): void {
    
    this._documents.update(docs => {
      const updated = docs.filter(doc => doc.docId !== docId);
      return updated;
    });
  }

  getState(): UploadState {
    return {
      documents: this._documents(),
      sessionId: this._sessionId()
    };
  }

   /**
   * ✅ Restore state from snapshot
   */
  setState(state: Partial<UploadState>): void {
    
    if (state.documents) this._documents.set(state.documents);
    if (state.sessionId) this._sessionId.set(state.sessionId);
  }

  resetState(): void {    
    this._documents.set([]);
    this._sessionId.set(`${Date.now()}`);
  }
}
